import type { Prize } from "./OtherAvailableCards";
import { Button } from "../ui/button";
import { useModal } from "@/hooks/useModal";
import { storeListings } from "@/helpers/storeListings";
import { PurchaseModal } from "../Modals/PurchaseModal";
import type { GameThemeId } from "@skillscratch/shared-types";


export function PrizeItem({ prize }: { prize: Prize }) {
    const { openModal } = useModal();

    const handleClick = (name: string) => {
        // No need for e.stopPropagation() here as we're handling it in the onClick
        
        const listing = storeListings.find((listing) => listing.name === name);
        
        if (!listing) {
            throw new Error("Listing not found");
        }
        
        const { id, prices } = listing;
        
        openModal(<PurchaseModal id={id as GameThemeId} prices={prices}/>);
    };

    return (
        <Button 
            variant={'bare'} 
            className="w-full h-full p-0 m-0 relative pointer-events-auto" 
            fillOnPress={true} 
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                handleClick(prize.name);
            }}
        >
            <div className="flex items-center p-4 relative z-20 text-left">
                <div className="flex-shrink-0 mr-4">
                    <img src={prize.src} alt="card-img" className={`h-20 rounded-sm border ${prize.borderColor}`} />
                </div>
                <div className="flex-grow">
                    <div className="text-black opacity-40 text-sm">{prize.name}. Up to:</div>
                    <div className={`text-2xl font-bold ${prize.textColor} flex items-center`}>
                        {prize.amount}
                        <span className={`ml-2 ${prize.bgColor} text-white rounded-full w-6 h-6 flex items-center justify-center`}>
                            {/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                            </svg>
                        </span>
                    </div>
                    <div className="text-black opacity-40">Just {prize.cost}</div>
                </div>
            </div>
        </Button>
    );
}